export const enum SampleProcessingState {
  UNPROCESSED = "UNPROCESSED",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  ERROR = "ERROR"
}

export const enum SummaryTabKey {
  DETAILS = "sample_details",
  MITRE = "mitre_attack",
  ANALYSIS_RESULTS = "analysis_results"
}
